import FooterCell from './FooterCell';
import { IColumn } from '../interfaces';

interface IProps {
  columns: IColumn[],
}

const FooterRow = ({ columns }: IProps) => (
  <tr>
    {
      columns.map((element) => (
        <FooterCell
          key={ element.name }
          dataTest={ element.name }
          { ...element }
        />
      ))
    }
  </tr>
);

export default FooterRow;
